import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

//CSS
import "./homePage.css";
import "../0PageStyles.css";

//Components
import EmailContactBox from "../../Components/Home Components/emailContactBox";
import Title from "../../Components/Other Components/Title";
import Hero from "../../Components/Home Components/Hero";
import Footer from "Components/Home Components/Footer";
import OfferView from "Components/Home Components/OfferView";
import StatsBar from "../../Components/Home Components/StatsBar";
import ShowcaseBlock from "../../Components/Home Components/ShowcaseBlock";

//Function
import { CheckIfLoggedIn } from "../../BackendAccess/UserHooks";

import PageWrapper from "../pageWrapper";

export default function HomePage() {
  const navigate = useNavigate();
  const { t } = useTranslation("home");
  const [loggedIn, setLoggedIn] = useState(null);

  useEffect(() => {
    if (loggedIn === null) checkIfUserIsLogedIn();
    else if (loggedIn) {
      navigate("/workspace/warehouses");
    }
  }, [loggedIn]);

  const checkIfUserIsLogedIn = async () => {
    const [data, error] = await CheckIfLoggedIn();
    if (error) setLoggedIn(false);
    else {
      setLoggedIn(data);
    }
  };

  //PACKAGES***********************************
  const cardData = [
    {
      title: t("packages.basic.title"),
      price: t("packages.basic.price"),
      color: "var(--CARDCOLOR1)",
      props: {
        [t("packages.props.warehouseCount")]: 1,
        [t("packages.props.itemCount")]: 5000,
        [t("packages.props.tagCount")]: 100,
        [t("packages.props.trafficData")]: false,
        [t("packages.props.employeeManagement")]: false,
        [t("packages.props.roleManagement")]: false,
        [t("packages.props.supportLevel")]: t("packages.basic.supportLevel"),
      },
    },
    {
      title: t("packages.pro.title"),
      price: t("packages.pro.price"),
      color: "var(--CARDCOLOR2)",
      props: {
        [t("packages.props.warehouseCount")]: 5,
        [t("packages.props.itemCount")]: 10000,
        [t("packages.props.tagCount")]: 1000,
        [t("packages.props.trafficData")]: t("packages.pro.trafficData"),
        [t("packages.props.employeeManagement")]: true,
        [t("packages.props.employeeCount")]: 100,
        [t("packages.props.roleManagement")]: true,
        [t("packages.props.roleCount")]: 50,
        [t("packages.props.supportLevel")]: t("packages.pro.supportLevel"),
      },
    },
    {
      title: t("packages.proPlus.title"),
      price: t("packages.proPlus.price"),
      color: "var(--CARDCOLOR3)",
      props: {
        [t("packages.props.warehouseCount")]: 50,
        [t("packages.props.itemCount")]: 50000,
        [t("packages.props.tagCount")]: t("packages.props.unlimited"),
        [t("packages.props.trafficData")]: t("packages.proPlus.trafficData"),
        [t("packages.props.employeeManagement")]: true,
        [t("packages.props.employeeCount")]: 1000,
        [t("packages.props.roleManagement")]: true,
        [t("packages.props.roleCount")]: 500,
        [t("packages.props.supportLevel")]: t("packages.proPlus.supportLevel"),
      },
    },
    {
      title: t("packages.lifetime.title"),
      price: t("packages.lifetime.price"),
      color: "var(--CARDCOLOR4)",
      props: {
        [t("packages.props.warehouseCount")]: t("packages.props.unlimited"),
        [t("packages.props.itemCount")]: t("packages.props.unlimited"),
        [t("packages.props.tagCount")]: t("packages.props.unlimited"),
        [t("packages.props.trafficData")]: t("packages.lifetime.trafficData"),
        [t("packages.props.employeeManagement")]: true,
        [t("packages.props.employeeCount")]: t("packages.props.unlimited"),
        [t("packages.props.roleManagement")]: true,
        [t("packages.props.roleCount")]: t("packages.props.unlimited"),
        [t("packages.props.supportLevel")]: t("packages.lifetime.supportLevel"),
      },
    },
  ];
  //PACKAGES END***************************************

  //SHOWCASE**************************************************

  const showcaseBlocks = [
    {
      side: "left",
      eyebrow: t("showcase.warehouses.eyebrow"),
      title: t("showcase.warehouses.title"),
      text: t("showcase.warehouses.text"),
      imgSrc: "/Images/showcase/ShowcaseWarehouses.png",
      bullets: [
        t("showcase.warehouses.bullet1"),
        t("showcase.warehouses.bullet2"),
        t("showcase.warehouses.bullet3"),
      ],
    },
    {
      side: "right",
      eyebrow: t("showcase.items.eyebrow"),
      title: t("showcase.items.title"),
      text: t("showcase.items.text"),
      imgSrc: "/Images/showcase/ShowcaseItems.png",
      bullets: [
        t("showcase.items.bullet1"),
        t("showcase.items.bullet2"),
        t("showcase.items.bullet3"),
      ],
    },
    {
      side: "left",
      eyebrow: t("showcase.report.eyebrow"),
      title: t("showcase.report.title"),
      text: t("showcase.report.text"),
      imgSrc: "/Images/showcase/ShowcaseReport.png",
      bullets: [
        t("showcase.report.bullet1"),
        t("showcase.report.bullet2"),
        t("showcase.report.bullet3"),
      ],
    },
    {
      side: "right",
      eyebrow: t("showcase.traffic.eyebrow"),
      title: t("showcase.traffic.title"),
      text: t("showcase.traffic.text"),
      imgSrc: "/Images/showcase/ShowcaseTraffic.png",
      bullets: [
        t("showcase.traffic.bullet1"),
        t("showcase.traffic.bullet2"),
        t("showcase.traffic.bullet3"),
      ],
    },
  ];

  const stats = [
    { value: 50, suffix: "+", label: t("stats.warehouses") },
    { value: 50000, suffix: "+", label: t("stats.items") },
    { value: 100, suffix: "%", label: t("stats.sync") },
    { value: 24, suffix: "/7", label: t("stats.support") },
  ];

  const handleNavigation = (path) => {
    setTimeout(() => {
      const element = document.getElementById(path);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  //SHOWCASE END******************************************

  return (
    <PageWrapper>
      <div className="page-content home-page">
        <Hero
          badge={t("hero.badge")}
          title={t("hero.title")}
          subtitle={t("hero.subtitle")}
          image={"UStorageHero.png"}
          btnText={t("hero.btnText")}
          onClick={() => navigate("/register")}
          btnText2={t("hero.btnText2")}
          onClick2={() => handleNavigation("AboutSection")}
        />
        <StatsBar stats={stats} />
        <div className="spacer xl"></div>
        <div id="AboutSection" className="AboutSection">
          <Title className="w-90">{t("sections.about")}</Title>
          <div className="spacer m"></div>
          {showcaseBlocks.map((block, i) => (
            <ShowcaseBlock key={i} {...block} />
          ))}
        </div>
        <div className="spacer xl"></div>
        <div id="PackageSection" className="packageSection">
          <Title className="w-90">{t("sections.packages")}</Title>

          <div className="spacer m"></div>
          <OfferView
            cards={cardData.map((item) => {
              return {
                ...item,
                onClick: () => {
                  navigate("/login");
                },
              };
            })}
          />
        </div>
        <div className="spacer xl"></div>

        <div id="ContactSection" className="ContactSection">
          <Title className="w-90">{t("sections.contact")}</Title>

          <div className="spacer m"></div>
          <EmailContactBox></EmailContactBox>
        </div>
        <Footer />
      </div>
    </PageWrapper>
  );
}
